import React from 'react';
import styled from 'styled-components';
import { Link as ReactRouterLink } from 'react-router-dom';

const FootContainer = styled.div`
    width: 100%;
    min-height: 100px;
    /* background: ${props => props.theme.color.scDarkGray3}; */
    background: linear-gradient(#425a29, #202d13);
    color: ${props => props.theme.color.scLightGray4};
    padding: ${props => props.theme.padding.xlrg} 0;
    z-index: 10;
`;
const FootInner = styled.div`
    max-width: ${props => props.theme.width.lrg};
    margin: 0 auto;
    align-self: flex-end;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;
const Column = styled.div`
    min-width: 200px;
    max-width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: ${props => props.theme.padding.lrg};
    box-sizing: border-box;
`;
const Title = styled.span`
    font-size: ${props => props.theme.font.xs};
    font-weight: 700;
    text-transform: uppercase;
    line-height: 32px;
    margin-bottom: 5px;
`;
const Link = styled.a`
    font-size: ${props => props.theme.font.xxs};
    color: ${props => props.theme.color.scLightGray4};
    transition: 0.2s;
    text-transform: uppercase;
    line-height: 32px;
    &:hover {
        color: ${props => props.theme.color.scLightGray2};
    }
`;
const StyledLink = styled(ReactRouterLink)`
    font-size: ${props => props.theme.font.xxs};
    color: ${props => props.theme.color.scLightGray4};
    transition: 0.2s;
    text-transform: uppercase;
    line-height: 32px;
    &:hover {
        color: ${props => props.theme.color.scLightGray2};
    }
`;

const Foot = ({ children }) => (
    <FootContainer>
        <FootInner>
            {children}
        </FootInner>
    </FootContainer>
);

Foot.Column = Column;
Foot.Title = Title;
Foot.Link = Link;
Foot.StyledLink = StyledLink;
export { Foot };



// WEBPACK FOOTER //
// ./src/sc-ui/Foot.jsx